module.exports = __webpack_public_path__ + "static/media/14.449a51d0.png";